<template>
  <div data-testid="fiscal-config-table" class="fiscal-config-table">
    <table v-if="rows.length > 0" class="fc-table">
      <thead>
        <tr>
          <th>{{ t('Franquia') }}</th>
          <th>{{ t('País') }}</th>
          <th>{{ t('Provedor') }}</th>
          <th>{{ t('Status') }}</th>
          <th>{{ t('Ação') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in rows" :key="row.franchise_id">
          <td>
            <span class="fc-id">#{{ row.franchise_id }}</span>
            {{ row.franchise_name }}
          </td>
          <td>{{ row.country || '—' }}</td>
          <td>{{ row.invoice_provider || '—' }}</td>
          <td>
            <Tag
              :severity="row.is_configured ? 'success' : 'warning'"
              :value="row.is_configured ? t('Configurado') : t('Pendente')" />
          </td>
          <td>
            <Button
              :label="t('Editar')"
              icon="pi pi-pencil"
              size="small"
              :data-testid="`fiscal-config-btn-edit-${row.franchise_id}`"
              @click="handleEdit(row.franchise_id)" />
          </td>
        </tr>
      </tbody>
    </table>
    <div v-else-if="loading" class="fc-empty" data-testid="fiscal-config-loading">
      <i class="pi pi-spinner pi-spin"></i> {{ t('Carregando...') }}
    </div>
    <div v-else class="fc-empty" data-testid="fiscal-config-empty">
      {{ t('Nenhuma franquia disponível para configuração fiscal.') }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { log } from '../../../utils/DebugLogger';

type Row = {
  franchise_id: number;
  franchise_name: string;
  country: string | null;
  invoice_provider: string | null;
  is_configured: boolean;
};

withDefaults(defineProps<{
  rows: Row[];
  loading?: boolean;
}>(), {
  loading: false,
});

const emit = defineEmits<{
  edit: [franchiseId: number];
}>();

const { t } = useI18n();

const handleEdit = (franchiseId: number): void => {
  log('FiscalConfigTable', 'handleEdit', 'Edit clicked', franchiseId);
  emit('edit', franchiseId);
};
</script>

<style scoped>
.fc-table {
  width: 100%;
  border-collapse: collapse;
}
.fc-table th,
.fc-table td {
  text-align: left;
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid var(--surface-200, #e5e7eb);
}
.fc-table th {
  background: var(--surface-100, #f3f4f6);
  font-weight: 600;
}
.fc-id {
  color: var(--text-color-secondary, #6b7280);
  margin-right: 0.5rem;
}
.fc-empty {
  padding: 1rem;
  color: var(--text-color-secondary, #6b7280);
}
</style>
